export const USER_ROLES = {
    'ADMIN': 'ADMIN',
    'MANAGER': 'MANAGER',
    'USER': 'USER',
}